import React from 'react';
import PropTypes from 'prop-types';
import { TicketMetricsCard } from './TicketMetricsCard';
import styles from './TicketMetricsSection.module.css';

export const TicketMetricsSection = ({ 
  metrics, 
  selectedMetric, 
  onMetricSelect 
}) => {
  const metricsData = [
    {
      key: 'daysToResolution',
      label: 'Mean Time to Resolution',
      value: metrics.meanTimeToResolution,
      variant: 'primary'
    },
    {
      key: 'pending',
      label: 'Pending',
      value: metrics.ticketsPending
    },
    {
      key: 'deferred',
      label: 'Deferred',
      value: metrics.ticketsDeferred
    },
    {
      key: 'workInProgress',
      label: 'Work In Progress',
      value: metrics.ticketsWorkInProgress
    },
    {
      key: 'closed',
      label: 'Closed',
      value: metrics.ticketsClosed
    }
  ];

  return (
    <div className={styles.section}>
      <div className={styles.metricsGrid}>
        {metricsData.map((metric) => (
          <TicketMetricsCard
            key={metric.key}
            label={metric.label}
            value={metric.value}
            variant={metric.variant}
            isSelected={selectedMetric === metric.key}
            onClick={() => onMetricSelect(metric.key)}
          />
        ))}
      </div>
    </div>
  );
};

TicketMetricsSection.propTypes = {
  metrics: PropTypes.shape({
    meanTimeToResolution: PropTypes.string.isRequired,
    ticketsPending: PropTypes.number.isRequired,
    ticketsClosed: PropTypes.number.isRequired,
    ticketsDeferred: PropTypes.number.isRequired,
    ticketsWorkInProgress: PropTypes.number.isRequired
  }).isRequired,
  selectedMetric: PropTypes.string,
  onMetricSelect: PropTypes.func.isRequired
};